import { render } from "./IframeIndex.vue?vue&type=template&id=297451ed&scoped=true&ts=true"
import script from "./IframeIndex.vue?vue&type=script&lang=ts"
export * from "./IframeIndex.vue?vue&type=script&lang=ts"

import "./IframeIndex.vue?vue&type=style&index=0&id=297451ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297451ed"]])

export default __exports__